import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes} from '@angular/router';
import {PaginationUtil} from 'ng-jhipster';
import {EntityAuditEventComponent} from './entity-audit-event.component';
import {EntityAuditEventDetailComponent} from './entity-audit-event-detail.component';
import {UserRouteAccessService} from "../../shared";

@Injectable()
export class EntityAuditEventResolvePagingParams implements Resolve<any> {

  constructor(private paginationUtil: PaginationUtil) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
      let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'commitVersion,desc';
      return {
          page: this.paginationUtil.parsePage(page),
          predicate: this.paginationUtil.parsePredicate(sort),
          ascending: this.paginationUtil.parseAscending(sort)
    };
  }
}

export const entityAuditEventRoute: Routes = [
  {
    path: 'entity-audit-event',
    component: EntityAuditEventComponent,
    resolve: {
      'pagingParams': EntityAuditEventResolvePagingParams
    },
    data: {
        authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST'],
        pageTitle: 'cadensApp.entityAuditEvent.home.title'
    },
      canActivate: [UserRouteAccessService]
  },{
        path: 'entity-audit-event/candidatureFormation/:id',
        component: EntityAuditEventComponent,
        resolve: {
            'pagingParams': EntityAuditEventResolvePagingParams
        },
        data: {
            authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST'],
            pageTitle: 'cadensApp.entityAuditEvent.home.title'
        },
        canActivate: [UserRouteAccessService]
    }, {
    path: 'entity-audit-event/:id',
    component: EntityAuditEventDetailComponent,
    data: {
        authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST'],
        pageTitle: 'cadensApp.entityAuditEvent.home.title'
    },
        canActivate: [UserRouteAccessService]
  }
];




// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/entity-audit-event/entity-audit-event.route.ts